import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: '4', label: 'No' },
    { value: '1', label: 'Aboriginal' },
    { value: '2', label: 'Torres Strait Islander' },
    { value: '3', label: 'Aboriginal and Torres Strait Islander' },
    { value: '9', label: 'Unspecified' },
  ],
});
